import {
  Col,
  Form,
  Input,
  Label,
  ModalBody,
  FormGroup,
  InputGroupText,
  InputGroup,
  Row
} from "reactstrap";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { P, H5 } from "../../../../../AbstractElements";
import { useState, Fragment, useCallback } from "react";
import { toast } from "react-toastify";
import { Btn } from "../../../../../AbstractElements";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import Dropzone from "react-dropzone";
import Swal from "sweetalert2";
import { Save } from "react-feather";

//TYPE AND SERVICES
import {
  ATTACHMENT_CATEGORY_QUERY_KEY,
  attachmentCategoryService,
} from "../../../../../Services/attachmentCategoryService";

import {
  APPLICANT_ATTACHMENTS_QUERY_KEY,
  applicantAttachmentsService,
} from "../../../../../Services/applicantsattachmentService";

//TYPES
import { AttachmentCategory } from "../../../../../Types/Attachments/AttachmentCategory";

//INTERFACE
interface ModalProps {
  attachment_id: number;
  category_id: number;
  file_name: string;
  toggle?: () => void;
}

const UpdateattachmentForm: React.FC<ModalProps> = ({
  toggle,
  attachment_id,
  category_id,
  file_name,
}) => {
  const queryClient = useQueryClient();
  const user = useAppSelector((state) => state.auth.user);
  const [files, setFiles] = useState([]);

  //GET ATTACHMENT CATEGORY
  const { data: categoryData, isLoading: CatagoryisLoading } = useQuery<{
    data: AttachmentCategory[];
  }>({
    queryKey: ATTACHMENT_CATEGORY_QUERY_KEY,
    queryFn: attachmentCategoryService.getAttachmentCategories,
  });

  const category: AttachmentCategory[] =
    categoryData?.data?.filter((item) => item.status === 1) ?? [];

  const [formData, setFormData] = useState({
    category_id: category_id,
  });

    const UpdateAttachmentsMutation = useMutation({
        mutationFn: (data: typeof formData) =>
          applicantAttachmentsService.updateAttachment(attachment_id, data.category_id),
        onSuccess: (result) => {
          queryClient.invalidateQueries();
          if (toggle) toggle();
          Swal.close();
          Swal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            icon: "success",
            title: "Transaction Successful",
            text: "Your remark has been saved successully.",
            confirmButtonColor: "#4e73df",
          });
        },
        onError: (error: any) => {
          const responseData = error.response?.data;
          Swal.close();
          Swal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            icon: "error",
            title: "Error",
            text: responseData?.message || "Failed to save the remark please try again.",
            confirmButtonColor: "#4e73df",
            
          });
        },
      });

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    Swal.fire({
        title: "Are you sure?",
        text: "Do you want to update this attachment?",
        icon: "question",
        showCancelButton: true,

        confirmButtonText: '<i class="fa fa-save"></i> Update Attachment',
        cancelButtonText: '<i class="fa fa-times"></i> Cancel',

        confirmButtonColor: "#4e73df", // Primary
        cancelButtonColor: "#dc3545",  // Danger
        allowOutsideClick: false,
        allowEscapeKey: false,

    }).then((result) => {
        if (result.isConfirmed) {
            Swal.fire({
                title: "Updating...",
                text: "Please wait while your attachemnt category is being update.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            UpdateAttachmentsMutation.mutate(formData);
        }
    });

  };

  return (
    <ModalBody className="mt-0">
      <Form className="needs-validation" onSubmit={handleSubmit}>
        <div className="d-flex justify-content-between align-items-center">
          <H5>{" "}</H5>
          <P className="mb-2">
            <i className="icofont icofont-exclamation-tringle txt-warning"></i>
            {" "}Fields marked with <b className="text-danger">*</b> are required
            {" "}
            <i className="icofont icofont-exclamation-tringle txt-warning"></i>
          </P>
        </div>
        <Row className="g-3">
            <H5 className="mt-1 mb-2">
                Attachment File: {file_name}
            </H5>
          <Col md="12">
            <FormGroup>
              <Label>Attachment Category <b className="text-danger">*</b></Label>
              <InputGroup>
                <InputGroupText>
                  <i className="icofont icofont-clip txt-primary"></i>
                </InputGroupText>
                <Input
                  type="select"
                  id="category_id"
                  name="category_id"
                  disabled={CatagoryisLoading ? true : false}
                  required
                  onChange={handleInputChange}
                  value={formData.category_id}
                >
                  <option value="" disabled selected>
                    {CatagoryisLoading ? "Loading..." : "- Select Attachment Category -"}
                  </option>
                  {!CatagoryisLoading &&
                    category.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Input>
              </InputGroup>
            </FormGroup>
          </Col>

          <Btn
            color="primary"
            type="submit"
            disabled={UpdateAttachmentsMutation.isPending}
          >
            <Save size={16} className="me-1"/>
            {UpdateAttachmentsMutation.isPending ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Updating Attachemnt Category...
              </>
            ) : (
              "Update"
            )}
          </Btn>
        </Row>
      </Form>
    </ModalBody>
  );
};

export default UpdateattachmentForm;
